import { Theme } from "@mui/material";
import { CSSObject } from "@mui/system";

export const createLabelCommonRoot = (theme: Theme): CSSObject => ({
  position: "static",
  transform: "none",
  color: theme.palette.text.primary,
  fontWeight: 600,
  lineHeight: 1.4,
  marginBottom: "4px",
  fontSize: "14px",
  marginRight: "auto",
  "& span": {
    color: theme.palette.text.primary,
  },
  "&.Mui-focused": {
    color: theme.palette.text.primary,
    "& span": {
      color: theme.palette.text.primary,
    },
  },
  "&.Mui-error": {
    color: theme.palette.text.primary,
    "& span": {
      color: theme.palette.text.primary,
    },
  },
  "&.Mui-disabled": {
    color: theme.palette.text.disabled,
    cursor: "not-allowed",
    "& span": {
      color: theme.palette.text.disabled,
    },
  },
});
